export default "__VITE_ASSET__Bb_P9T_i__"